// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { Routes } from '../../types/routes';
import { RoutePatterns } from '../../types/routes';

type Params = {
  sportId?: number;
  categoryId?: number;
  tournamentId?: number;
};

export const getCatalogRoute = (params: Params): string => {
  const { sportId, categoryId, tournamentId } = params;
  let route = '';
  if (tournamentId !== undefined) {
    route = `${Routes.TOURNAMENT}:${tournamentId}`;
  } else if (categoryId !== undefined) {
    route = `${Routes.CATEGORY}:${categoryId}`;
  } else if (sportId !== undefined) {
    route = `${Routes.SPORT}:${sportId}`;
  }
  return route;
};

export const isCatalog = (pathname: string): boolean =>
  !!matchPath(pathname, {
    path: RoutePatterns.CATALOG,
    exact: true,
  });
